import { render, staticRenderFns } from "./TDatePicker.vue?vue&type=template&id=ecdce292&"
import script from "./TDatePicker.vue?vue&type=script&lang=js&"
export * from "./TDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./TDatePicker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TDatePicker.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./TDatePicker.vue?vue&type=custom&index=1&blockType=docs"
if (typeof block1 === 'function') block1(component)

export default component.exports